import { apiRequest } from "./client";

export type InquiryFields = { name: string; email: string; phone: string; message: string; product_listing_id?: number };

/** A question about a part, or a general one (PRD 5.12). Visitors may ask too. */
export const inquiryApi = {
  send: (inquiry: InquiryFields) => apiRequest<void>("/api/v1/inquiries", { method: "POST", body: { inquiry } }),
};
